import { ChartConfiguration } from '@common-modules/shared/charts/model/chart/chart-configuration';
import { TextConfiguration } from '@common-modules/shared/core/text/text-configuration';
import { GridConfiguration } from '@common-modules/shared/grid/grid-configuration';

export interface IWidgetSettings {}

export class ChartWidgetSettings implements IWidgetSettings {
  chartConfiguration: ChartConfiguration;
}

export class GridWidgetSettings implements IWidgetSettings {
  gridConfiguration: GridConfiguration;
}

export class TextWidgetSettings implements IWidgetSettings {
  textConfiguration: TextConfiguration;
}
